import axios from "axios";

const AxiosTokens = () => {
    const generateCancellationToken = () => axios.CancelToken.source()
    return { generateCancellationToken };
};

export default AxiosTokens;